import { EssayAnswer } from "@verity/api-client/types";
import { AnswerStatusChip } from "./shared";
import type { QuizResponseResult } from "../hooks/verityAssessmentResultHelper.js";

/** Manually graded — just presents what the student wrote, no correctness check. */
export function EssayAnswerView({ response }: { response: QuizResponseResult | undefined }) {
	const userAnswers: EssayAnswer = (response?.answer as EssayAnswer) ?? "";
	if (response?.isAnswered !== true || !userAnswers.trim()) {
		return <AnswerStatusChip userText="" isCorrect={null} style={{ margin: "0" }} />;
	}
	return userAnswers;
}
